module.exports = __webpack_public_path__ + "static/media/ats@2x.451c0ffe.png";